import React from 'react';
import {useTranslation} from 'react-i18next';
import {durationLabel, resolveStepAction} from '../../portal_usage/portalUsageState';

/**
 * Lo que hizo el asistente para responder una consulta.
 *
 * Va en un componente aparte porque es la única parte del turno con montaje condicional: cerrado,
 * este panel NO existe en el DOM. Con 25 turnos de ~5 pasos serían ~125 nodos y otras tantas
 * entradas en el árbol de accesibilidad para contenido que nadie pidió, y un `Ctrl+F` que encuentra
 * texto dentro de un panel colapsado al que el navegador no scrollea es peor que no encontrarlo.
 * Los cuatro disclosures que ya existen en el repo desmontan igual.
 *
 * El título nombra al sujeto de una vez: los verbos en pasado son del ASISTENTE, no del cliente.
 * Sin eso, «Leyó el contexto del cliente» se lee como algo que hizo la persona.
 */
export function PortalTurnSteps({steps, panelId, title}) {
    const {t, i18n} = useTranslation();
    const list = steps || [];
    if (!list.length) return null;

    return (
        <div className="pu-steps" id={panelId} role="region" aria-label={title}>
            <p className="pu-steps__title">{title}</p>
            <ol className="pu-steps__list">
                {list.map((step, index) => (
                    <StepRow key={step.id || index} step={step} t={t} language={i18n.language}/>
                ))}
            </ol>
        </div>
    );
}

function StepRow({step, t, language}) {
    const action = resolveStepAction(step);
    const duration = durationLabel(step.duration_ms, t, language);

    return (
        <li className={`pu-step${step.failed ? ' -failed' : ''}`}>
            <span className="pu-step__lbl">{t(action.key, action.fallback)}</span>
            {/* El `tool_name` NO es superficie de producto: es un identificador interno. Aparece
                sólo cuando no sabemos traducir la acción — ahí el nombre técnico se lee como
                «esto es nuevo», que es la verdad, en vez de dejar la fila muda. */}
            {!action.known && step.tool_name ? <code className="pu-step__tool">{step.tool_name}</code> : null}
            <span className="pu-step__meta">
                {step.failed ? (
                    <span className="pu-step__err">{t('portal_usage.step_failed', 'falló')}</span>
                ) : null}
                {duration ? <span>{duration}</span> : null}
            </span>
        </li>
    );
}

export default PortalTurnSteps;
